// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"239":"91657037cabce04f","5107":"d50abc0f8cda346d"}[chunkId] + ".css";
};